import script from "./componentTemplate.vue?vue&type=script&lang=js"
export * from "./componentTemplate.vue?vue&type=script&lang=js"

import "./componentTemplate.vue?vue&type=style&index=0&id=4b9c15c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9c15c8"]])

export default __exports__